import { createReducer, on } from '@ngrx/store';

import {
  clearSearchBarDataAction,
  selectDepartureDateAction
} from '@shared/base-search-bar/store/actions/search-bar.actions';
import { loadSearchDataSuccessAction } from '@shared/base-search-bar/store/actions/storage.actions';

export const initialState: Date | null = null;

export const departureDateReducer = createReducer(
  initialState,
  on(selectDepartureDateAction, (state, { date }) => {
    return date;
  }),
  on(loadSearchDataSuccessAction, (state, { data, exchange }) => {
    if (exchange) {
      return data?.departureDate ? new Date(data.departureDate) : null;
    } else {
      if (data) {
        if (data.departureDate) {
          const departure = new Date(data.departureDate);
          const now = new Date(new Date().setHours(0, 0, 0, 0));
          return departure.getTime() >= now.getTime() ? new Date(data.departureDate) : null;
        } else return state ? state : null;
      } else return null;
    }
  }),
  on(clearSearchBarDataAction, () => initialState)
);
